module.exports = __webpack_public_path__ + "static/media/EEKHeaderImage-1.14fa69f1.JPG";